import request from "@/utils/request"

const addSpaceMember = ({ nickname, inviteCode }) =>
  request.post("/api/spaces/members", {
    body: {
      nickname,
      invite_code: inviteCode // eslint-disable-line camelcase
    },
    token: true
  })

export default {
  addSpaceMember
}
